/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { BakendHttpResponse } from '../bakend-http-response';

import { BackendActualMaterialDto } from '../models/backend-actual-material-dto';
import { BackendActualOtherOpexDto } from '../models/backend-actual-other-opex-dto';
import { BackendActualProductDto } from '../models/backend-actual-product-dto';
import { BackendActualRentDto } from '../models/backend-actual-rent-dto';
import { BackendActualSalaryDto } from '../models/backend-actual-salary-dto';
import { monitoringActualsMaterialsCopyCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-copy-create';
import { MonitoringActualsMaterialsCopyCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-copy-create';
import { monitoringActualsMaterialsCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-create';
import { monitoringActualsMaterialsCreate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-create-form-data';
import { MonitoringActualsMaterialsCreate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-create-form-data';
import { MonitoringActualsMaterialsCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-create';
import { monitoringActualsMaterialsCreate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-create-x-www-form-urlencoded';
import { MonitoringActualsMaterialsCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-create-x-www-form-urlencoded';
import { monitoringActualsMaterialsDestroy } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-destroy';
import { MonitoringActualsMaterialsDestroy$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-destroy';
import { monitoringActualsMaterialsList } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-list';
import { MonitoringActualsMaterialsList$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-list';
import { monitoringActualsMaterialsPartialUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-partial-update';
import { monitoringActualsMaterialsPartialUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-partial-update-form-data';
import { MonitoringActualsMaterialsPartialUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-partial-update-form-data';
import { MonitoringActualsMaterialsPartialUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-partial-update';
import { monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-partial-update-x-www-form-urlencoded';
import { MonitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-partial-update-x-www-form-urlencoded';
import { monitoringActualsMaterialsRetrieve } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-retrieve';
import { MonitoringActualsMaterialsRetrieve$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-retrieve';
import { monitoringActualsMaterialsUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-update';
import { monitoringActualsMaterialsUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-update-form-data';
import { MonitoringActualsMaterialsUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-update-form-data';
import { MonitoringActualsMaterialsUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-update';
import { monitoringActualsMaterialsUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-update-x-www-form-urlencoded';
import { MonitoringActualsMaterialsUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-materials-update-x-www-form-urlencoded';
import { monitoringActualsOtherOpexesCopyCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-copy-create';
import { MonitoringActualsOtherOpexesCopyCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-copy-create';
import { monitoringActualsOtherOpexesCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-create';
import { monitoringActualsOtherOpexesCreate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-create-form-data';
import { MonitoringActualsOtherOpexesCreate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-create-form-data';
import { MonitoringActualsOtherOpexesCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-create';
import { monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-create-x-www-form-urlencoded';
import { MonitoringActualsOtherOpexesCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-create-x-www-form-urlencoded';
import { monitoringActualsOtherOpexesDestroy } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-destroy';
import { MonitoringActualsOtherOpexesDestroy$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-destroy';
import { monitoringActualsOtherOpexesList } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-list';
import { MonitoringActualsOtherOpexesList$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-list';
import { monitoringActualsOtherOpexesPartialUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-partial-update';
import { monitoringActualsOtherOpexesPartialUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-partial-update-form-data';
import { MonitoringActualsOtherOpexesPartialUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-partial-update-form-data';
import { MonitoringActualsOtherOpexesPartialUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-partial-update';
import { monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-partial-update-x-www-form-urlencoded';
import { MonitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-partial-update-x-www-form-urlencoded';
import { monitoringActualsOtherOpexesRetrieve } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-retrieve';
import { MonitoringActualsOtherOpexesRetrieve$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-retrieve';
import { monitoringActualsOtherOpexesUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-update';
import { monitoringActualsOtherOpexesUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-update-form-data';
import { MonitoringActualsOtherOpexesUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-update-form-data';
import { MonitoringActualsOtherOpexesUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-update';
import { monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-update-x-www-form-urlencoded';
import { MonitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-other-opexes-update-x-www-form-urlencoded';
import { monitoringActualsProductsCopyCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-copy-create';
import { MonitoringActualsProductsCopyCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-copy-create';
import { monitoringActualsProductsCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-create';
import { monitoringActualsProductsCreate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-create-form-data';
import { MonitoringActualsProductsCreate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-create-form-data';
import { MonitoringActualsProductsCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-create';
import { monitoringActualsProductsCreate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-create-x-www-form-urlencoded';
import { MonitoringActualsProductsCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-create-x-www-form-urlencoded';
import { monitoringActualsProductsDestroy } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-destroy';
import { MonitoringActualsProductsDestroy$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-destroy';
import { monitoringActualsProductsList } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-list';
import { MonitoringActualsProductsList$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-list';
import { monitoringActualsProductsPartialUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-partial-update';
import { monitoringActualsProductsPartialUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-partial-update-form-data';
import { MonitoringActualsProductsPartialUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-partial-update-form-data';
import { MonitoringActualsProductsPartialUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-partial-update';
import { monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-partial-update-x-www-form-urlencoded';
import { MonitoringActualsProductsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-partial-update-x-www-form-urlencoded';
import { monitoringActualsProductsRetrieve } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-retrieve';
import { MonitoringActualsProductsRetrieve$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-retrieve';
import { monitoringActualsProductsUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-update';
import { monitoringActualsProductsUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-update-form-data';
import { MonitoringActualsProductsUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-update-form-data';
import { MonitoringActualsProductsUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-update';
import { monitoringActualsProductsUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-update-x-www-form-urlencoded';
import { MonitoringActualsProductsUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-products-update-x-www-form-urlencoded';
import { monitoringActualsRentsCopyCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-copy-create';
import { MonitoringActualsRentsCopyCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-copy-create';
import { monitoringActualsRentsCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-create';
import { monitoringActualsRentsCreate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-create-form-data';
import { MonitoringActualsRentsCreate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-create-form-data';
import { MonitoringActualsRentsCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-create';
import { monitoringActualsRentsCreate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-create-x-www-form-urlencoded';
import { MonitoringActualsRentsCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-create-x-www-form-urlencoded';
import { monitoringActualsRentsDestroy } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-destroy';
import { MonitoringActualsRentsDestroy$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-destroy';
import { monitoringActualsRentsList } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-list';
import { MonitoringActualsRentsList$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-list';
import { monitoringActualsRentsPartialUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-partial-update';
import { monitoringActualsRentsPartialUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-partial-update-form-data';
import { MonitoringActualsRentsPartialUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-partial-update-form-data';
import { MonitoringActualsRentsPartialUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-partial-update';
import { monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-partial-update-x-www-form-urlencoded';
import { MonitoringActualsRentsPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-partial-update-x-www-form-urlencoded';
import { monitoringActualsRentsRetrieve } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-retrieve';
import { MonitoringActualsRentsRetrieve$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-retrieve';
import { monitoringActualsRentsUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-update';
import { monitoringActualsRentsUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-update-form-data';
import { MonitoringActualsRentsUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-update-form-data';
import { MonitoringActualsRentsUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-update';
import { monitoringActualsRentsUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-update-x-www-form-urlencoded';
import { MonitoringActualsRentsUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-rents-update-x-www-form-urlencoded';
import { monitoringActualsSalariesCopyCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-copy-create';
import { MonitoringActualsSalariesCopyCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-copy-create';
import { monitoringActualsSalariesCreate } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-create';
import { monitoringActualsSalariesCreate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-create-form-data';
import { MonitoringActualsSalariesCreate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-create-form-data';
import { MonitoringActualsSalariesCreate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-create';
import { monitoringActualsSalariesCreate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-create-x-www-form-urlencoded';
import { MonitoringActualsSalariesCreate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-create-x-www-form-urlencoded';
import { monitoringActualsSalariesDestroy } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-destroy';
import { MonitoringActualsSalariesDestroy$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-destroy';
import { monitoringActualsSalariesList } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-list';
import { MonitoringActualsSalariesList$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-list';
import { monitoringActualsSalariesPartialUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-partial-update';
import { monitoringActualsSalariesPartialUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-partial-update-form-data';
import { MonitoringActualsSalariesPartialUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-partial-update-form-data';
import { MonitoringActualsSalariesPartialUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-partial-update';
import { monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-partial-update-x-www-form-urlencoded';
import { MonitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-partial-update-x-www-form-urlencoded';
import { monitoringActualsSalariesRetrieve } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-retrieve';
import { MonitoringActualsSalariesRetrieve$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-retrieve';
import { monitoringActualsSalariesUpdate } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-update';
import { monitoringActualsSalariesUpdate$FormData } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-update-form-data';
import { MonitoringActualsSalariesUpdate$FormData$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-update-form-data';
import { MonitoringActualsSalariesUpdate$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-update';
import { monitoringActualsSalariesUpdate$XWwwFormUrlencoded } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-update-x-www-form-urlencoded';
import { MonitoringActualsSalariesUpdate$XWwwFormUrlencoded$Params } from '../fn/monitoring-actual-opexes/monitoring-actuals-salaries-update-x-www-form-urlencoded';

@Injectable({ providedIn: 'root' })
export class BackendApiMonitoringActualOpexesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `monitoringActualsMaterialsList()` */
  static readonly MonitoringActualsMaterialsListPath = '/api/monitoring/actuals/materials/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsList$Response(
    params?: MonitoringActualsMaterialsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualMaterialDto>>> {
    return monitoringActualsMaterialsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsList(
    params?: MonitoringActualsMaterialsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualMaterialDto>> {
    return this.monitoringActualsMaterialsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualMaterialDto>>): Array<BackendActualMaterialDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsMaterialsCreate()` */
  static readonly MonitoringActualsMaterialsCreatePath = '/api/monitoring/actuals/materials/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsMaterialsCreate$Response(
    params: MonitoringActualsMaterialsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsMaterialsCreate(
    params: MonitoringActualsMaterialsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsMaterialsCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsMaterialsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsMaterialsCreate$XWwwFormUrlencoded(
    params: MonitoringActualsMaterialsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsMaterialsCreate$FormData$Response(
    params: MonitoringActualsMaterialsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsMaterialsCreate$FormData(
    params: MonitoringActualsMaterialsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsMaterialsRetrieve()` */
  static readonly MonitoringActualsMaterialsRetrievePath = '/api/monitoring/actuals/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsRetrieve$Response(
    params: MonitoringActualsMaterialsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsRetrieve(
    params: MonitoringActualsMaterialsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsMaterialsUpdate()` */
  static readonly MonitoringActualsMaterialsUpdatePath = '/api/monitoring/actuals/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsMaterialsUpdate$Response(
    params: MonitoringActualsMaterialsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsMaterialsUpdate(
    params: MonitoringActualsMaterialsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsMaterialsUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsMaterialsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsMaterialsUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsMaterialsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsMaterialsUpdate$FormData$Response(
    params: MonitoringActualsMaterialsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsMaterialsUpdate$FormData(
    params: MonitoringActualsMaterialsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsMaterialsDestroy()` */
  static readonly MonitoringActualsMaterialsDestroyPath = '/api/monitoring/actuals/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsDestroy$Response(
    params: MonitoringActualsMaterialsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsMaterialsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsDestroy(
    params: MonitoringActualsMaterialsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsMaterialsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsMaterialsPartialUpdate()` */
  static readonly MonitoringActualsMaterialsPartialUpdatePath = '/api/monitoring/actuals/materials/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsMaterialsPartialUpdate$Response(
    params: MonitoringActualsMaterialsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsMaterialsPartialUpdate(
    params: MonitoringActualsMaterialsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsMaterialsPartialUpdate$FormData$Response(
    params: MonitoringActualsMaterialsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsMaterialsPartialUpdate$FormData(
    params: MonitoringActualsMaterialsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsMaterialsCopyCreate()` */
  static readonly MonitoringActualsMaterialsCopyCreatePath = '/api/monitoring/actuals/materials/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsMaterialsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsCopyCreate$Response(
    params: MonitoringActualsMaterialsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualMaterialDto>> {
    return monitoringActualsMaterialsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsMaterialsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsMaterialsCopyCreate(
    params: MonitoringActualsMaterialsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualMaterialDto> {
    return this.monitoringActualsMaterialsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualMaterialDto>): BackendActualMaterialDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesList()` */
  static readonly MonitoringActualsOtherOpexesListPath = '/api/monitoring/actuals/other-opexes/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesList$Response(
    params?: MonitoringActualsOtherOpexesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualOtherOpexDto>>> {
    return monitoringActualsOtherOpexesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesList(
    params?: MonitoringActualsOtherOpexesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualOtherOpexDto>> {
    return this.monitoringActualsOtherOpexesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualOtherOpexDto>>): Array<BackendActualOtherOpexDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesCreate()` */
  static readonly MonitoringActualsOtherOpexesCreatePath = '/api/monitoring/actuals/other-opexes/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOtherOpexesCreate$Response(
    params: MonitoringActualsOtherOpexesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOtherOpexesCreate(
    params: MonitoringActualsOtherOpexesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsOtherOpexesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded(
    params: MonitoringActualsOtherOpexesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOtherOpexesCreate$FormData$Response(
    params: MonitoringActualsOtherOpexesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOtherOpexesCreate$FormData(
    params: MonitoringActualsOtherOpexesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesRetrieve()` */
  static readonly MonitoringActualsOtherOpexesRetrievePath = '/api/monitoring/actuals/other-opexes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesRetrieve$Response(
    params: MonitoringActualsOtherOpexesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesRetrieve(
    params: MonitoringActualsOtherOpexesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesUpdate()` */
  static readonly MonitoringActualsOtherOpexesUpdatePath = '/api/monitoring/actuals/other-opexes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOtherOpexesUpdate$Response(
    params: MonitoringActualsOtherOpexesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOtherOpexesUpdate(
    params: MonitoringActualsOtherOpexesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOtherOpexesUpdate$FormData$Response(
    params: MonitoringActualsOtherOpexesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOtherOpexesUpdate$FormData(
    params: MonitoringActualsOtherOpexesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesDestroy()` */
  static readonly MonitoringActualsOtherOpexesDestroyPath = '/api/monitoring/actuals/other-opexes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesDestroy$Response(
    params: MonitoringActualsOtherOpexesDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsOtherOpexesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesDestroy(
    params: MonitoringActualsOtherOpexesDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsOtherOpexesDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesPartialUpdate()` */
  static readonly MonitoringActualsOtherOpexesPartialUpdatePath = '/api/monitoring/actuals/other-opexes/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOtherOpexesPartialUpdate$Response(
    params: MonitoringActualsOtherOpexesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsOtherOpexesPartialUpdate(
    params: MonitoringActualsOtherOpexesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOtherOpexesPartialUpdate$FormData$Response(
    params: MonitoringActualsOtherOpexesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsOtherOpexesPartialUpdate$FormData(
    params: MonitoringActualsOtherOpexesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsOtherOpexesCopyCreate()` */
  static readonly MonitoringActualsOtherOpexesCopyCreatePath = '/api/monitoring/actuals/other-opexes/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsOtherOpexesCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesCopyCreate$Response(
    params: MonitoringActualsOtherOpexesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
    return monitoringActualsOtherOpexesCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsOtherOpexesCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsOtherOpexesCopyCreate(
    params: MonitoringActualsOtherOpexesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualOtherOpexDto> {
    return this.monitoringActualsOtherOpexesCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualOtherOpexDto>): BackendActualOtherOpexDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsList()` */
  static readonly MonitoringActualsProductsListPath = '/api/monitoring/actuals/products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsList$Response(
    params?: MonitoringActualsProductsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualProductDto>>> {
    return monitoringActualsProductsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsList(
    params?: MonitoringActualsProductsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualProductDto>> {
    return this.monitoringActualsProductsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualProductDto>>): Array<BackendActualProductDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsCreate()` */
  static readonly MonitoringActualsProductsCreatePath = '/api/monitoring/actuals/products/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsProductsCreate$Response(
    params: MonitoringActualsProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsProductsCreate(
    params: MonitoringActualsProductsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsProductsCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsProductsCreate$XWwwFormUrlencoded(
    params: MonitoringActualsProductsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsProductsCreate$FormData$Response(
    params: MonitoringActualsProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsProductsCreate$FormData(
    params: MonitoringActualsProductsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsRetrieve()` */
  static readonly MonitoringActualsProductsRetrievePath = '/api/monitoring/actuals/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsRetrieve$Response(
    params: MonitoringActualsProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsRetrieve(
    params: MonitoringActualsProductsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsUpdate()` */
  static readonly MonitoringActualsProductsUpdatePath = '/api/monitoring/actuals/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsProductsUpdate$Response(
    params: MonitoringActualsProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsProductsUpdate(
    params: MonitoringActualsProductsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsProductsUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsProductsUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsProductsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsProductsUpdate$FormData$Response(
    params: MonitoringActualsProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsProductsUpdate$FormData(
    params: MonitoringActualsProductsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsDestroy()` */
  static readonly MonitoringActualsProductsDestroyPath = '/api/monitoring/actuals/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsDestroy$Response(
    params: MonitoringActualsProductsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsProductsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsDestroy(
    params: MonitoringActualsProductsDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsProductsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsPartialUpdate()` */
  static readonly MonitoringActualsProductsPartialUpdatePath = '/api/monitoring/actuals/products/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsProductsPartialUpdate$Response(
    params: MonitoringActualsProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsProductsPartialUpdate(
    params: MonitoringActualsProductsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsProductsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsProductsPartialUpdate$FormData$Response(
    params: MonitoringActualsProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsProductsPartialUpdate$FormData(
    params: MonitoringActualsProductsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsProductsCopyCreate()` */
  static readonly MonitoringActualsProductsCopyCreatePath = '/api/monitoring/actuals/products/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsProductsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsCopyCreate$Response(
    params: MonitoringActualsProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualProductDto>> {
    return monitoringActualsProductsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsProductsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsProductsCopyCreate(
    params: MonitoringActualsProductsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualProductDto> {
    return this.monitoringActualsProductsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualProductDto>): BackendActualProductDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsList()` */
  static readonly MonitoringActualsRentsListPath = '/api/monitoring/actuals/rents/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsList$Response(
    params?: MonitoringActualsRentsList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualRentDto>>> {
    return monitoringActualsRentsList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsList(
    params?: MonitoringActualsRentsList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualRentDto>> {
    return this.monitoringActualsRentsList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualRentDto>>): Array<BackendActualRentDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsCreate()` */
  static readonly MonitoringActualsRentsCreatePath = '/api/monitoring/actuals/rents/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsRentsCreate$Response(
    params: MonitoringActualsRentsCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsRentsCreate(
    params: MonitoringActualsRentsCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsRentsCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsRentsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsRentsCreate$XWwwFormUrlencoded(
    params: MonitoringActualsRentsCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsRentsCreate$FormData$Response(
    params: MonitoringActualsRentsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsRentsCreate$FormData(
    params: MonitoringActualsRentsCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsRetrieve()` */
  static readonly MonitoringActualsRentsRetrievePath = '/api/monitoring/actuals/rents/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsRetrieve$Response(
    params: MonitoringActualsRentsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsRetrieve(
    params: MonitoringActualsRentsRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsUpdate()` */
  static readonly MonitoringActualsRentsUpdatePath = '/api/monitoring/actuals/rents/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsRentsUpdate$Response(
    params: MonitoringActualsRentsUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsRentsUpdate(
    params: MonitoringActualsRentsUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsRentsUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsRentsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsRentsUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsRentsUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsRentsUpdate$FormData$Response(
    params: MonitoringActualsRentsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsRentsUpdate$FormData(
    params: MonitoringActualsRentsUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsDestroy()` */
  static readonly MonitoringActualsRentsDestroyPath = '/api/monitoring/actuals/rents/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsDestroy$Response(
    params: MonitoringActualsRentsDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsRentsDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsDestroy(params: MonitoringActualsRentsDestroy$Params, context?: HttpContext): Observable<void> {
    return this.monitoringActualsRentsDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsPartialUpdate()` */
  static readonly MonitoringActualsRentsPartialUpdatePath = '/api/monitoring/actuals/rents/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsRentsPartialUpdate$Response(
    params: MonitoringActualsRentsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsRentsPartialUpdate(
    params: MonitoringActualsRentsPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsRentsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsRentsPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsRentsPartialUpdate$FormData$Response(
    params: MonitoringActualsRentsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsRentsPartialUpdate$FormData(
    params: MonitoringActualsRentsPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsRentsCopyCreate()` */
  static readonly MonitoringActualsRentsCopyCreatePath = '/api/monitoring/actuals/rents/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsRentsCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsCopyCreate$Response(
    params: MonitoringActualsRentsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualRentDto>> {
    return monitoringActualsRentsCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsRentsCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsRentsCopyCreate(
    params: MonitoringActualsRentsCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualRentDto> {
    return this.monitoringActualsRentsCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualRentDto>): BackendActualRentDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesList()` */
  static readonly MonitoringActualsSalariesListPath = '/api/monitoring/actuals/salaries/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesList()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesList$Response(
    params?: MonitoringActualsSalariesList$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<Array<BackendActualSalaryDto>>> {
    return monitoringActualsSalariesList(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesList$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesList(
    params?: MonitoringActualsSalariesList$Params,
    context?: HttpContext,
  ): Observable<Array<BackendActualSalaryDto>> {
    return this.monitoringActualsSalariesList$Response(params, context).pipe(
      map((r: BakendHttpResponse<Array<BackendActualSalaryDto>>): Array<BackendActualSalaryDto> => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesCreate()` */
  static readonly MonitoringActualsSalariesCreatePath = '/api/monitoring/actuals/salaries/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalariesCreate$Response(
    params: MonitoringActualsSalariesCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalariesCreate(
    params: MonitoringActualsSalariesCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesCreate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalariesCreate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsSalariesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesCreate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesCreate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalariesCreate$XWwwFormUrlencoded(
    params: MonitoringActualsSalariesCreate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesCreate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesCreate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalariesCreate$FormData$Response(
    params: MonitoringActualsSalariesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesCreate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesCreate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalariesCreate$FormData(
    params: MonitoringActualsSalariesCreate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesCreate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesRetrieve()` */
  static readonly MonitoringActualsSalariesRetrievePath = '/api/monitoring/actuals/salaries/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesRetrieve()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesRetrieve$Response(
    params: MonitoringActualsSalariesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesRetrieve(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesRetrieve$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesRetrieve(
    params: MonitoringActualsSalariesRetrieve$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesRetrieve$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesUpdate()` */
  static readonly MonitoringActualsSalariesUpdatePath = '/api/monitoring/actuals/salaries/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalariesUpdate$Response(
    params: MonitoringActualsSalariesUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalariesUpdate(
    params: MonitoringActualsSalariesUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalariesUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsSalariesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalariesUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsSalariesUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalariesUpdate$FormData$Response(
    params: MonitoringActualsSalariesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalariesUpdate$FormData(
    params: MonitoringActualsSalariesUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesDestroy()` */
  static readonly MonitoringActualsSalariesDestroyPath = '/api/monitoring/actuals/salaries/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesDestroy()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesDestroy$Response(
    params: MonitoringActualsSalariesDestroy$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<void>> {
    return monitoringActualsSalariesDestroy(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesDestroy$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesDestroy(
    params: MonitoringActualsSalariesDestroy$Params,
    context?: HttpContext,
  ): Observable<void> {
    return this.monitoringActualsSalariesDestroy$Response(params, context).pipe(
      map((r: BakendHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesPartialUpdate()` */
  static readonly MonitoringActualsSalariesPartialUpdatePath = '/api/monitoring/actuals/salaries/{id}/';

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesPartialUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalariesPartialUpdate$Response(
    params: MonitoringActualsSalariesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesPartialUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesPartialUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  monitoringActualsSalariesPartialUpdate(
    params: MonitoringActualsSalariesPartialUpdate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesPartialUpdate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded$Response(
    params: MonitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded$Response()` instead.
   *
   * This method sends `application/x-www-form-urlencoded` and handles request body of type `application/x-www-form-urlencoded`.
   */
  monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded(
    params: MonitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesPartialUpdate$XWwwFormUrlencoded$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesPartialUpdate$FormData()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalariesPartialUpdate$FormData$Response(
    params: MonitoringActualsSalariesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesPartialUpdate$FormData(this.http, this.rootUrl, params, context);
  }

  /**
   * Конфигурация:
   *     project_lookup: str — ORM-путь к Project из модели queryset'а.
   *         'pk' — для viewset'а на самом Project.
   *         'project' — для модели с FK 'project' (default).
   *         'variant__project', 'scenario__project' — для вложенных.
   *
   * Использование:
   *     class MyView(ProjectScopedQuerysetMixin, generics.ListAPIView):
   *         project_lookup = 'pk'
   *         def get_queryset(self):
   *             if getattr(self, 'swagger_fake_view', False):
   *                 return Project.objects.none()
   *             return self.filter_by_view_access(Project.objects.filter(active=True))
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesPartialUpdate$FormData$Response()` instead.
   *
   * This method sends `multipart/form-data` and handles request body of type `multipart/form-data`.
   */
  monitoringActualsSalariesPartialUpdate$FormData(
    params: MonitoringActualsSalariesPartialUpdate$FormData$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesPartialUpdate$FormData$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }

  /** Path part for operation `monitoringActualsSalariesCopyCreate()` */
  static readonly MonitoringActualsSalariesCopyCreatePath = '/api/monitoring/actuals/salaries/copy/{id}/';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `monitoringActualsSalariesCopyCreate()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesCopyCreate$Response(
    params: MonitoringActualsSalariesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BakendHttpResponse<BackendActualSalaryDto>> {
    return monitoringActualsSalariesCopyCreate(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `monitoringActualsSalariesCopyCreate$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  monitoringActualsSalariesCopyCreate(
    params: MonitoringActualsSalariesCopyCreate$Params,
    context?: HttpContext,
  ): Observable<BackendActualSalaryDto> {
    return this.monitoringActualsSalariesCopyCreate$Response(params, context).pipe(
      map((r: BakendHttpResponse<BackendActualSalaryDto>): BackendActualSalaryDto => r.body),
    );
  }
}
